
export const state = () => {
    return {
        columns: [],
        fixedColumns: [],
        sortedColumns: [],
        headerRows: [],
        bodyRows: [],
        footerRows: []
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/table_v3/state.js